module.exports = function() {
    return function debug() {
        // empty mock of debug module for browser usage
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-parser-xo/browserify/debug-mock.js
// module id = ./node_modules/xml-parser-xo/browserify/debug-mock.js
// module chunks = 0